// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.projects-page {
  background-color: rgba(var(--white));
  box-sizing: border-box;
}
.projects-page__header {
  padding: 3rem 6.875rem 0;
}
@media (max-width: 768px) {
  .projects-page__header {
    padding: 1.75rem 1rem 1.25rem;
    height: 2.5rem;
  }
}
.projects-page__content {
  padding: 0 6.875rem 3rem;
}
@media (max-width: 768px) {
  .projects-page__content {
    padding: 0;
  }
}
.projects-page__content-main {
  background-color: rgba(var(--grey-100));
  border-radius: 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 3rem;
  margin-bottom: 6.25rem;
  cursor: pointer;
}
@media (max-width: 768px) {
  .projects-page__content-main {
    flex-direction: column-reverse;
    margin: 1.5rem 1rem;
    border-radius: 1.5rem;
  }
}
.projects-page__content-main-info {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 0 3rem;
}
@media (max-width: 768px) {
  .projects-page__content-main-info {
    padding: 0 1rem;
    gap: 0.125rem;
  }
}
.projects-page__content-main-title {
  font-family: var(--merriweather);
  font-size: 2.5rem;
  line-height: 1.25;
  font-weight: 400;
  color: rgba(var(--grey-800));
}
@media (max-width: 768px) {
  .projects-page__content-main-title {
    font-size: 1.3125rem;
    line-height: 1.42;
    margin-top: 1.5rem;
  }
}
.projects-page__content-main-description {
  font-size: 1rem;
  line-height: 1.625;
  font-weight: 400;
  color: rgba(var(--grey-600));
  max-width: 346px;
}
@media (max-width: 768px) {
  .projects-page__content-main-description {
    font-size: 0.875rem;
    line-height: 1.857;
  }
}
.projects-page__content-main > img {
  object-fit: cover;
  height: 29.875rem;
  border-radius: 2rem;
}
@media (max-width: 1200px) {
  .projects-page__content-main > img {
    height: 23rem;
  }
}
@media (max-width: 1025px) {
  .projects-page__content-main > img {
    height: 20rem;
  }
}
@media (max-width: 768px) {
  .projects-page__content-main > img {
    height: 12.4375rem;
    border-radius: 1.5rem;
    width: 100%;
  }
}
.projects-page__content-blocks {
  display: flex;
  flex-direction: column;
  gap: 5rem;
  margin-bottom: 6.25rem;
}
@media (max-width: 768px) {
  .projects-page__content-blocks {
    gap: 1.5rem;
    margin-bottom: 3.5rem;
  }
}
.projects-page__title {
  font-size: 2rem;
  line-height: 1.3;
  font-weight: 500;
  color: rgba(var(--grey-800));
}
@media (max-width: 768px) {
  .projects-page__title {
    font-size: 1.5rem;
    line-height: 1.3;
    padding: 0 1rem;
    margin-top: 0.75rem;
  }
}
.projects-page-button {
  width: max-content;
  display: flex !important;
  align-items: center;
}
.projects-page-button__icon {
  margin-left: 0.5rem;
}
@media (max-width: 768px) {
  .projects-page-button {
    margin-top: 0.75rem;
    margin-bottom: 1.5rem;
    justify-content: center;
  }
}
.projects-page__item-header {
  display: flex;
  align-items: center;
  gap: 0.875rem;
  width: max-content;
  cursor: pointer !important;
}
@media (max-width: 768px) {
  .projects-page__item-header {
    padding: 0 1rem;
  }
}
.projects-page__item-header:hover .projects-page__item-title,
.projects-page__item-header:hover i {
  color: rgba(var(--orange)) !important;
}
.projects-page__item-title {
  font-family: var(--merriweather);
  font-size: 1.5rem;
  line-height: 1.3;
  font-weight: 400;
  color: rgba(var(--grey-800));
  transition: color 0.3s ease-in-out;
}
@media (max-width: 768px) {
  .projects-page__item-title {
    font-size: 1.25rem;
    line-height: 1.6;
  }
}
.projects-page__item i {
  cursor: pointer !important;
  transition: color 0.3s ease-in-out;
}
.projects-page__item-imgs {
  box-sizing: border-box;
  margin-top: 1.5rem;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-content: space-between;
  width: 100%;
  grid-gap: 2.5rem;
}
@media (max-width: 768px) {
  .projects-page__item-imgs {
    display: flex;
    justify-content: flex-start;
    position: relative;
    overflow-x: auto;
    margin-top: 0.875rem;
    gap: 0.625rem;
    padding: 0 1rem;
  }
}
.projects-page__item-img {
  height: 24.5625rem;
  width: 100%;
  border-radius: 1rem;
  background-color: rgba(var(--blue-grey-300));
  object-fit: cover;
  cursor: pointer;
}
@media (max-width: 1200px) {
  .projects-page__item-img {
    height: 18rem;
  }
}
@media (max-width: 768px) {
  .projects-page__item-img {
    height: 10.9375rem;
    width: 9.375rem;
    flex-shrink: 0;
  }
}
.projects-page .swiper-slide {
  height: auto !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Projects/styles.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;EACA,sBAAA;AACF;AACE;EACE,wBAAA;AACJ;AACI;EAHF;IAII,6BAAA;IACA,cAAA;EAEJ;AACF;AACE;EACE,wBAAA;AACJ;AACI;EAHF;IAII,UAAA;EAEJ;AACF;AAAI;EACE,uCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;AAEN;AAAM;EAVF;IAWI,8BAAA;IACA,mBAAA;IACA,qBAAA;EAGN;AACF;AADM;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;AAGR;AADQ;EANF;IAOI,eAAA;IACA,aAAA;EAIR;AACF;AADM;EACE,gCAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;AAGR;AADQ;EAPF;IAQI,oBAAA;IACA,iBAAA;IACA,kBAAA;EAIR;AACF;AADM;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,gBAAA;AAGR;AADQ;EAPF;IAQI,mBAAA;IACA,kBAAA;EAIR;AACF;AADM;EACE,iBAAA;EACA,iBAAA;EACA,mBAAA;AAGR;AADQ;EALF;IAMI,aAAA;EAIR;AACF;AAFQ;EATF;IAUI,aAAA;EAKR;AACF;AAHQ;EAbF;IAcI,kBAAA;IACA,qBAAA;IACA,WAAA;EAMR;AACF;AAFI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,sBAAA;AAIN;AAFM;EANF;IAOI,WAAA;IACA,qBAAA;EAKN;AACF;AADE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;AAGJ;AADI;EANF;IAOI,iBAAA;IACA,gBAAA;IACA,eAAA;IACA,mBAAA;EAIJ;AACF;AADE;EACE,kBAAA;EACA,wBAAA;EACA,mBAAA;AAGJ;AADI;EACE,mBAAA;AAGN;AAAI;EATF;IAUI,mBAAA;IACA,qBAAA;IACA,uBAAA;EAGJ;AACF;AACI;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,0BAAA;AACN;AACM;EAPF;IAQI,eAAA;EAEN;AACF;AACQ;;EAEE,qCAAA;AACV;AAII;EACE,gCAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,kCAAA;AAFN;AAIM;EARF;IASI,kBAAA;IACA,gBAAA;EADN;AACF;AAII;EACE,0BAAA;EACA,kCAAA;AAFN;AAKI;EACE,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,qCAAA;EACA,8BAAA;EACA,WAAA;EACA,gBAAA;AAHN;AAKM;EATF;IAUI,aAAA;IACA,2BAAA;IACA,kBAAA;IACA,gBAAA;IACA,oBAAA;IACA,aAAA;IACA,eAAA;EAFN;AACF;AAKI;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,4CAAA;EACA,iBAAA;EACA,eAAA;AAHN;AAKM;EARF;IASI,aAAA;EAFN;AACF;AAIM;EAZF;IAaI,kBAAA;IACA,eAAA;IACA,cAAA;EADN;AACF;AAKE;EACE,uBAAA;AAHJ","sourcesContent":[".projects-page {\n  background-color: rgba(var(--white));\n  box-sizing: border-box;\n\n  &__header {\n    padding: 3rem 6.875rem 0;\n\n    @media (max-width: 768px) {\n      padding: 1.75rem 1rem 1.25rem;\n      height: 2.5rem;\n    }\n  }\n\n  &__content {\n    padding: 0 6.875rem 3rem;\n\n    @media (max-width: 768px) {\n      padding: 0;\n    }\n\n    &-main {\n      background-color: rgba(var(--grey-100));\n      border-radius: 2rem;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      margin-top: 3rem;\n      margin-bottom: 6.25rem;\n      cursor: pointer;\n\n      @media (max-width: 768px) {\n        flex-direction: column-reverse;\n        margin: 1.5rem 1rem;\n        border-radius: 1.5rem;\n      }\n\n      &-info {\n        display: flex;\n        flex-direction: column;\n        gap: 1.5rem;\n        padding: 0 3rem;\n\n        @media (max-width: 768px) {\n          padding: 0 1rem;\n          gap: 0.125rem;\n        }\n      }\n\n      &-title {\n        font-family: var(--merriweather);\n        font-size: 2.5rem;\n        line-height: 1.25;\n        font-weight: 400;\n        color: rgba(var(--grey-800));\n\n        @media (max-width: 768px) {\n          font-size: 1.3125rem;\n          line-height: 1.42;\n          margin-top: 1.5rem;\n        }\n      }\n\n      &-description {\n        font-size: 1rem;\n        line-height: 1.625;\n        font-weight: 400;\n        color: rgba(var(--grey-600));\n        max-width: 346px;\n\n        @media (max-width: 768px) {\n          font-size: 0.875rem;\n          line-height: 1.857;\n        }\n      }\n\n      & > img {\n        object-fit: cover;\n        height: 29.875rem;\n        border-radius: 2rem;\n\n        @media (max-width: 1200px) {\n          height: 23rem;\n        }\n\n        @media (max-width: 1025px) {\n          height: 20rem;\n        }\n\n        @media (max-width: 768px) {\n          height: 12.4375rem;\n          border-radius: 1.5rem;\n          width: 100%;\n        }\n      }\n    }\n\n    &-blocks {\n      display: flex;\n      flex-direction: column;\n      gap: 5rem;\n      margin-bottom: 6.25rem;\n\n      @media (max-width: 768px) {\n        gap: 1.5rem;\n        margin-bottom: 3.5rem;\n      }\n    }\n  }\n\n  &__title {\n    font-size: 2rem;\n    line-height: 1.3;\n    font-weight: 500;\n    color: rgba(var(--grey-800));\n\n    @media (max-width: 768px) {\n      font-size: 1.5rem;\n      line-height: 1.3;\n      padding: 0 1rem;\n      margin-top: 0.75rem;\n    }\n  }\n\n  &-button {\n    width: max-content;\n    display: flex !important;\n    align-items: center;\n\n    &__icon {\n      margin-left: 0.5rem;\n    }\n\n    @media (max-width: 768px) {\n      margin-top: 0.75rem;\n      margin-bottom: 1.5rem;\n      justify-content: center;\n    }\n  }\n\n  &__item {\n    &-header {\n      display: flex;\n      align-items: center;\n      gap: 0.875rem;\n      width: max-content;\n      cursor: pointer !important;\n\n      @media (max-width: 768px) {\n        padding: 0 1rem;\n      }\n\n      &:hover {\n        .projects-page__item-title,\n        i {\n          color: rgba(var(--orange)) !important;\n        }\n      }\n    }\n\n    &-title {\n      font-family: var(--merriweather);\n      font-size: 1.5rem;\n      line-height: 1.3;\n      font-weight: 400;\n      color: rgba(var(--grey-800));\n      transition: color 0.3s ease-in-out;\n\n      @media (max-width: 768px) {\n        font-size: 1.25rem;\n        line-height: 1.6;\n      }\n    }\n\n    i {\n      cursor: pointer !important;\n      transition: color 0.3s ease-in-out;\n    }\n\n    &-imgs {\n      box-sizing: border-box;\n      margin-top: 1.5rem;\n      display: grid;\n      grid-template-columns: repeat(3, 1fr);\n      justify-content: space-between;\n      width: 100%;\n      grid-gap: 2.5rem;\n\n      @media (max-width: 768px) {\n        display: flex;\n        justify-content: flex-start;\n        position: relative;\n        overflow-x: auto;\n        margin-top: 0.875rem;\n        gap: 0.625rem;\n        padding: 0 1rem;\n      }\n    }\n\n    &-img {\n      height: 24.5625rem;\n      width: 100%;\n      border-radius: 1rem;\n      background-color: rgba(var(--blue-grey-300));\n      object-fit: cover;\n      cursor: pointer;\n\n      @media (max-width: 1200px) {\n        height: 18rem;\n      }\n\n      @media (max-width: 768px) {\n        height: 10.9375rem;\n        width: 9.375rem;\n        flex-shrink: 0;\n      }\n    }\n  }\n\n  .swiper-slide {\n    height: auto !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
